/** 
 * @file Defines the {@link BUTTON_PSEUDO_STATES} constant 
 * @author Joe Thompson <joe.thompson@1x2network.com>
*/

/**
 * Button pseudo states.
 * @type {string[]}
 * @constant
 * @default
 */
const BUTTON_PSEUDO_STATES = [

    'disabled',
    'down',
    'over',
    'up'

]

export { BUTTON_PSEUDO_STATES }